/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "enum.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

export enum PartyType {
   PP = 'PP',
   RQ = 'RQ',
   PA = 'PA',
   GA = 'GA'
}


/** end of template "enum.velocity" */
